/* sv-cart-cofnij (wizja koszyka K2, sesja 7ea9476e, 10.10.2026; karta c-usun: CEO „tak”, „to zbuduj”): po usunięciu pozycji
   koszem „Usuń” na stronie /cart pasek na dole ekranu „Usunięto: <produkt>. Cofnij” na 8 s. „Cofnij” dodaje tę samą pozycję
   z powrotem (wariant, ilość, ukryte właściwości, plan sprzedaży), potem odświeża stronę i po cichu szufladę.
   - Stan koszyka trzymamy w pamięci (cart.js po każdej zmianie, zdarzenie cartUpdate), bo kliknięcie w kosz uruchamia usuwanie
     od razu, a dane linii są potrzebne przed nim.
   - Prezent (przycisk z data-sv-gift-remove) bez „Cofnij”: wraca własnym przyciskiem w koszyku (cart-gift.js).
   - Teksty z elementu #sv-cofnij-teksty (sections/main-cart-items.liquid), 8 języków sklepu. */
(function () {
  if (window.svCartUndoReady) return;
  window.svCartUndoReady = true;

  var cartState = null;
  var pending = null;
  var toast = null;
  var hideTimer = null;
  var textsEl = document.getElementById('sv-cofnij-teksty');
  var T = textsEl ? textsEl.dataset : {};
  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

  function loadState() {
    return fetch(cartUrl + '.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartState = c; return c; })
      .catch(function () {});
  }

  function hideToast() {
    clearTimeout(hideTimer);
    if (toast) toast.hidden = true;
  }

  /* przegląd (drobne 3): region role=status istnieje przed komunikatem (czytnik ekranu go ogłosi), tekst po chwili; pasek nie
     znika, gdy klientka ma na nim kursor albo fokus (WCAG 2.2.1) */
  function ensureToast() {
    if (toast) return;
    toast = document.createElement('div');
    toast.className = 'sv-cofnij';
    toast.hidden = true;
    var txt = document.createElement('span');
    txt.className = 'sv-cofnij__tekst';
    txt.setAttribute('role', 'status');
    txt.setAttribute('aria-live', 'polite');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sv-cofnij__przycisk';
    btn.addEventListener('click', undo);
    toast.appendChild(txt);
    toast.appendChild(btn);
    ['mouseenter', 'focusin'].forEach(function (ev) { toast.addEventListener(ev, function () { clearTimeout(hideTimer); }); });
    ['mouseleave', 'focusout'].forEach(function (ev) {
      toast.addEventListener(ev, function () { clearTimeout(hideTimer); hideTimer = setTimeout(hideToast, 4000); });
    });
    document.body.appendChild(toast);
  }

  function showToast(item) {
    ensureToast();
    var txt = toast.querySelector('.sv-cofnij__tekst');
    var btn = toast.querySelector('button');
    btn.textContent = T.undo || 'Cofnij';
    btn.disabled = false;
    btn.hidden = false;
    txt.textContent = '';
    toast.hidden = false;
    setTimeout(function () { txt.textContent = (T.removed || 'Usunięto: [title]').replace('[title]', item.title); }, 50);
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hideToast, 8000);
  }

  /* K2 (10.10 ~23:05, uwaga CEO: po dodaniu z karty na telefonie zostaje widok stopki): krótki komunikat „Dodano do koszyka: X”
     w tym samym pasku co „Cofnij”, bez przycisku i bez przewijania (klientka zostaje przy przycisku kasy). Woła product-form.js. */
  window.svCartNote = function (title) {
    ensureToast();
    var txt = toast.querySelector('.sv-cofnij__tekst');
    var btn = toast.querySelector('button');
    pending = null;
    btn.hidden = true;
    txt.textContent = '';
    toast.hidden = false;
    setTimeout(function () { txt.textContent = (T.added || 'Dodano do koszyka: [title]').replace('[title]', title); }, 50);
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hideToast, 4000);
  };

  function refreshAll(cartData) {
    var page = document.querySelector('cart-items');
    if (page && typeof page.onCartUpdate === 'function') page.onCartUpdate();
    /* origin 'page': szuflada przerysowuje się po cichu (cart.js svRefreshDrawer), prezent synchronizuje cart-gift.js */
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', origin: 'page', cartData: cartData || null });
    }
  }

  function undo() {
    if (!pending || !pending.removed) return;
    if (typeof window.svTrack === 'function') window.svTrack('sv_cart_qty', { action: 'undo', ui_from: 'cart_page' });
    var item = pending;
    pending = null;
    var btn = toast && toast.querySelector('button');
    if (btn) btn.disabled = true;
    var line = { id: item.id, quantity: item.quantity };
    if (item.properties && Object.keys(item.properties).length) line.properties = item.properties;
    if (item.selling_plan) line.selling_plan = item.selling_plan;
    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [line] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add ' + r.status);
        return loadState();
      })
      .then(function (c) {
        hideToast();
        refreshAll(c);
      })
      .catch(function () {
        if (toast) {
          toast.querySelector('.sv-cofnij__tekst').textContent = T.failed || '';
          if (btn) btn.hidden = true;
          clearTimeout(hideTimer);
          hideTimer = setTimeout(function () { hideToast(); if (btn) btn.hidden = false; }, 6000);
        }
      });
  }

  /* kliknięcie w kosz: zapamiętaj linię, zanim cart.js ją usunie (faza przechwytywania, przed jego obsługą) */
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest('cart-items cart-remove-button');
      if (!button || button.closest('cart-drawer')) return;
      if (button.hasAttribute('data-sv-gift-remove')) { pending = null; return; }
      /* linia po kluczu z linku usuwania (/cart/change?id=<klucz>), bo numer linii bywa nieaktualny (np. torba dodana
         przełącznikiem, prezent dzielący linię); gdy stanu brak, dane z wiersza w liście */
      var key = null;
      var link = button.querySelector('a[href*="change"]');
      var m = link && /[?&]id=([^&]+)/.exec(link.getAttribute('href') || '');
      if (m) key = decodeURIComponent(m[1]);
      var items = (cartState && cartState.items) || [];
      var index = parseInt(button.dataset.index, 10) - 1;
      var it = key ? items.filter(function (i) { return i.key === key; })[0] : items[index];
      if (!it && key) {
        var row = button.closest('tr, .cart-item');
        var qi = row && row.querySelector('input[data-quantity-variant-id]');
        var nm = row && row.querySelector('.cart-item__name');
        it = { key: key, variant_id: parseInt(key.split(':')[0], 10), quantity: qi ? parseInt(qi.value, 10) || 1 : 1, properties: {},
               product_title: nm ? nm.textContent.trim() : '', variant_title: '' };
      }
      if (!it) { pending = null; return; }
      /* przegląd W2: wiersz łączy linie tego samego wariantu i właściwości (prezent dzieli urządzenie: 2 szt. = 2 linie po 1),
         a usunięcie zeruje je wszystkie - „Cofnij” przywraca sumę; usunięcie rozpoznajemy po wariancie, nie po kluczu linii */
      var pj = JSON.stringify(it.properties || {});
      var same = items.filter(function (i) {
        return i.variant_id === it.variant_id && JSON.stringify(i.properties || {}) === pj && !(i.properties && i.properties._sv_gift);
      });
      var qty = same.reduce(function (n, i) { return n + i.quantity; }, 0) || it.quantity;
      pending = {
        key: it.key,
        variant: it.variant_id,
        pj: pj,
        id: it.variant_id,
        quantity: qty,
        properties: it.properties || {},
        selling_plan: it.selling_plan_allocation && it.selling_plan_allocation.selling_plan ? it.selling_plan_allocation.selling_plan.id : null,
        title: it.product_title + (it.variant_title && it.variant_title !== 'Default Title' ? ' (' + it.variant_title + ')' : ''),
        removed: false
      };
    },
    true
  );

  function onUpdate(event) {
    var data = event && event.cartData;
    if (data && data.items) cartState = data;
    else loadState();
    /* usunięcie robi cart.js albo cart-gift.js (gdy w koszyku jest prezent: jedno zapytanie /cart/update.js, zdarzenie bez
       origin) - dlatego liczy się każda zmiana koszyka po kliknięciu kosza na stronie, a nie tylko zdarzenie z origin 'page' */
    if (!pending || pending.removed || !event || event.source !== 'cart-items' || !data || !data.items) return;
    var still = data.items.some(function (i) {
      return i.variant_id === pending.variant && JSON.stringify(i.properties || {}) === pending.pj && !(i.properties && i.properties._sv_gift);
    });
    if (!still) {
      pending.removed = true;
      showToast(pending);
    } else {
      pending = null;
    }
  }

  function start() {
    ensureToast();
    loadState();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, onUpdate);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
